import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";
import Amount from "@/models/Shared/Amount";
import RichDataSource from "@/models/Accounts/Shared/Transactions/RichDataSource";

export default class Transaction extends BaseInstitutionEntity {
    amount: Amount;
    availableBalance: string;
    balance: string;
    bulkPayment: boolean;
    createdAtUtc: Date;
    debitCreditCode: string;
    displayDate: number;
    displayDateUtc: Date;
    scheduledPayment: boolean;
    subTransactionType: string;
    transactionId: string;
    transactionReference: string;
    transactionType: string;
    walletId: string;
    paymentInstructionId: string;
    endToEndId: string;
    mandateId: string;
    paymentOrderId: string;
    counterpartyName: string;
    creditorName: string;
    richdata: string;
    richdatasource: RichDataSource;
    metadata: JSON;
}